/**
 * Debug utility for logging information conditionally based on REACT_APP_DEBUG environment variable
 */

// Check if debug mode is enabled via environment variable
const isDebugMode = process.env.REACT_APP_DEBUG === 'true';

/**
 * Log debug information if debug mode is enabled
 * @param message - The message to log
 * @param data - Optional data to log
 */
export const debug = {
  log: (message: string, data?: any) => {
    if (isDebugMode) {
      if (data) {
        console.log(`[DEBUG] ${message}`, data);
      } else {
        console.log(`[DEBUG] ${message}`);
      }
    }
  },
  
  error: (message: string, error?: any) => {
    if (isDebugMode) {
      if (error) {
        console.error(`[DEBUG ERROR] ${message}`, error);
      } else {
        console.error(`[DEBUG ERROR] ${message}`);
      }
    }
  },
  
  warn: (message: string, data?: any) => {
    if (isDebugMode) {
      if (data) {
        console.warn(`[DEBUG WARN] ${message}`, data);
      } else {
        console.warn(`[DEBUG WARN] ${message}`);
      }
    }
  },
  
  info: (message: string, data?: any) => {
    if (isDebugMode) {
      if (data) {
        console.info(`[DEBUG INFO] ${message}`, data);
      } else {
        console.info(`[DEBUG INFO] ${message}`);
      }
    }
  },
  
  group: (label: string) => {
    if (isDebugMode) {
      console.group(`[DEBUG GROUP] ${label}`);
    }
  },
  
  groupEnd: () => {
    if (isDebugMode) {
      console.groupEnd();
    }
  }
};

export default debug;